export default __webpack_public_path__ + "static/media/TRADE-1.33213a1d.jpg";